module.exports = __webpack_public_path__ + "static/media/international-vod.9bb36e43.vtt";